import React, { useEffect, useState } from 'react';
import CarouselHomeSection from '@componentsV2/CarouselHomeSection';
import PropertyImagesSection from './PropertyImagesSection';
import Grid from '../../../../../components/atomic/Grid';
import useDesktop from '../../../../../hooks/useDesktop';
import { DocumentationActionsSection } from './DocumentationActionsSection';
import BuildYourBoligmappeSection from './BuildYourBoligmappeSection';
import { PropertyInfoSection } from './PropertyInfoSection';
import { PropertyDocumentsSection } from './PropertyDocumentsSection';
import { PropertyCompaniesSection } from './PropertyCompaniesSection';
import OtovoInfoSection from './OtovoInforSection';
import { getPropertyType } from '../../../../../utils/properties';
import { useActiveProperty } from '../../../../../store/hooks';
import {
  enableHjemlaFinancialPage,
  enableOtovo,
  uxSignalScriptURL,
} from '../../../../../config';
import Box from '../../../../../components/atomic/Box';
import Link from '../../../../../components/atomic/Link';
import useDashboardLinkPrefix from '../../../../../hooks/useDashboardLinkPrefix';
import useScript from '../../../../../hooks/useScript';
import BoligmappePlusSection from './BoligmappaPlusSection';
import { isNativeEnv } from '../../../../../utils/nativeBridge';
import { useBoligmappaPlusSubscriptionStatus } from '../../../../../store/hooks/useBoligmappaPlusSubscriptionStatus';

const Overview = () => {
  const isDesktop = useDesktop();
  const [landTypeProperty, setLandTypeProperty] = useState();
  const { property } = useActiveProperty();
  const isNative = isNativeEnv();
  const dashboardLinkPrefix = useDashboardLinkPrefix();
  const boligmappaPlusSubscriptionStatus =
    useBoligmappaPlusSubscriptionStatus();

  useScript(true, uxSignalScriptURL);

  useEffect(() => {
    if (getPropertyType(property) === 'Eiendom/tomt uten bygning') {
      setLandTypeProperty(true);
    }
  }, []);

  if (enableOtovo === 'true') {
    return (
      <>
        {enableHjemlaFinancialPage === 'true' && (
          <Box mb={5}>
            <Link to={`${dashboardLinkPrefix}/financials/hjemla`}>
              <strong>Hjemla Financials Test Page</strong>
            </Link>
          </Box>
        )}

        <Grid container spacing={isDesktop ? 6 : 2}>
          {!boligmappaPlusSubscriptionStatus && !isNative && (
            <BoligmappePlusSection maxWidth />
          )}
          {isDesktop && <PropertyImagesSection />}
          <PropertyDocumentsSection />
          {isDesktop && <PropertyInfoSection />}
          {isDesktop && <CarouselHomeSection />}
          <OtovoInfoSection />
          <BuildYourBoligmappeSection maxWidth={false} />
          {!isDesktop && <CarouselHomeSection />}
          <DocumentationActionsSection />
          <PropertyCompaniesSection />
          {!isDesktop && <PropertyImagesSection />}
          {!isDesktop && <PropertyInfoSection />}
        </Grid>
      </>
    );
  }
  return (
    <Grid container spacing={isDesktop ? 6 : 2}>
      {/* {enableEventExperimentCTA && <EventExperimentCTASection />} */}
      {!boligmappaPlusSubscriptionStatus && !isNative && (
        <BoligmappePlusSection maxWidth />
      )}
      {isDesktop && <PropertyImagesSection />}
      <PropertyDocumentsSection />
      {isDesktop && <PropertyInfoSection />}
      {isDesktop && <CarouselHomeSection />}
      {!isDesktop && <CarouselHomeSection />}
      <DocumentationActionsSection />
      {!landTypeProperty && <BuildYourBoligmappeSection maxWidth />}
      <PropertyCompaniesSection />
      {!isDesktop && <PropertyImagesSection />}
      {!isDesktop && <PropertyInfoSection />}
    </Grid>
  );
};

export default Overview;
